// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nkLT","colBig":"styles_colBig__W8B9N","colSmall":"styles_colSmall__KuXZ7"};